export const CAMPAIGN_NAME = 'ดีลสุดคุ้ม แรงหยุดโลก';

export const EXPIRED_DATE_TEXT = '31 ธันวาคม 2569';

/** Where share links land. */
export const CAMPAIGN_PATH = '/register';

/** `lead-*` field event `text` labels. */
export const FORM_FIELD_LABELS: Record<string, string> = {
  fullname: 'ชื่อ - นามสกุล',
  phoneNumber: 'เบอร์โทรศัพท์',
  type: 'เลขบัตรประชาชน / เลขหนังสือเดินทาง',
  citizenId: 'เลขบัตรประชาชน / เลขหนังสือเดินทาง',
  modelCode: 'เลือกรุ่นรถที่สนใจ',
  province: 'จังหวัด',
  district: 'อำเภอ',
  dealer: 'ผู้จำหน่าย',
  privacy: 'นโยบายความเป็นส่วนตัว และเงื่อนไขและข้อกำหนด',
};

/** Fields whose chosen value is tracked; never typed ones (name, phone, ID). */
export const TRACKED_VALUE_FIELDS = [
  'type',
  'modelCode',
  'province',
  'district',
  'dealer',
  'privacy',
] as const;

/** Share-link gift box amount (fixed). */
export const SHARE_REVEAL_DISCOUNT = 50000;

/** Share message (Facebook ignores it). */
export const SHARE_HASHTAGS = [
  '#พลังใหม่ไบเทอร์โบแรงหยุดโลก',
  '#TheAbsolutePower',
  '#แรงกว่าเร็วกว่าประหยัดน้ำมันกว่า',
  '#isuzu',
];
export const SHARE_MESSAGE = SHARE_HASHTAGS.join('\n');

const OG_IMAGE = 'https://assets.isuzu-tis.com/campaign_og_1e9186d806.jpg';

/** /register meta tags: sharer (default) and receiver (share link). */
export const REGISTER_METADATA = {
  default: {
    title: CAMPAIGN_NAME,
    description: 'ลงทะเบียนรับข้อเสนอพิเศษและทดลองขับ',
    img: OG_IMAGE,
    url: CAMPAIGN_PATH,
  },
  shareLink: {
    title: CAMPAIGN_NAME,
    description: 'รับของขวัญจากครอบครัว! ลงทะเบียนรับส่วนลดซื้อรถใหม่',
    img: OG_IMAGE,
    url: CAMPAIGN_PATH,
  },
};

export const KV_IMAGE = {
  mobile:
    'https://assets.isuzu-tis.com/CRE_AW_CAMPAIGN_MU_X_and_D_MAX_DEAL_2048x2048_26_N_bbb660ba4d.jpg',
  tablet:
    'https://assets.isuzu-tis.com/AW_CAMPAIGN_MU_X_D_MAX_DEAL_1920x1080_NEW_26_d47e0a3d02.jpg',
  desktop:
    'https://assets.isuzu-tis.com/CRE_AW_CAMPAIGN_MU_X_and_D_MAX_DEAL_1400x2560_26_N_303b392254.jpg',
};

export const RegisterStep = {
  form: 1,
  spin: 2,
  summary: 3,
} as const;

export const FORM_ID = 'BIG_CAMPAIGN_2026';

export const MODEL_GROUP_LABEL: Record<string, string> = {
  pickup: 'รถปิกอัพ',
  ppv: 'รถอเนกประสงค์',
};

/** Spin artwork. */
export const SPIN_ASSETS = {
  backgroundMobile:
    'https://assets.isuzu-tis.com/register_mobile_bg_b5c000c9fe.png',
  backgroundDesktop:
    'https://assets.isuzu-tis.com/register_desktop_bg_be9508c1ff.png',
  heading: 'https://assets.isuzu-tis.com/heading_title_cbf7bab1aa.png',
  engine: 'https://assets.isuzu-tis.com/ring_rv_2_7047c74faf.png',
  blower: 'https://assets.isuzu-tis.com/blower_ec609a409e.png',
  blowerRing: 'https://assets.isuzu-tis.com/blower_ring_a816d5f0fc.png',
  breeze: 'https://assets.isuzu-tis.com/breeze_rv_2_c4854e3b45.png',
  effect: 'https://assets.isuzu-tis.com/effect_rv_2_33da8d51f2.png',
  fire: 'https://assets.isuzu-tis.com/fire_fc8dc3fb90.png',
  confetti: 'https://assets.isuzu-tis.com/confetti_2a7751b0bc.png',
  startButton: 'https://assets.isuzu-tis.com/start_button_rv_2_a251c59fec.png',
  tapIcon: 'https://assets.isuzu-tis.com/push_start_icon_b679416dcd.svg',
} as const;

/** Flare behind the spin card and share box. */
export const CIRCLE_FLARE =
  'https://assets.isuzu-tis.com/spin_circle_flare_7c8cf9b875.png';

/** Share-link reveal art. */
export const SHARE_ASSETS = {
  fromMyMember:
    'https://assets.isuzu-tis.com/share_from_my_member_e5d23007df.png',
  openBox: 'https://assets.isuzu-tis.com/share_open_box_a0763d280e.png',
  boxConfetti: 'https://assets.isuzu-tis.com/share_box_confetti_ab8e05df24.png',
} as const;

export const EXTRA_DISCOUNT_MAX = 10000;

export const EXTRA_DISCOUNT_VEHICLES = [
  'รถอีซูซุมือสอง',
  'รถยนต์ยี่ห้ออื่น',
  'รถจักรยานยนต์',
  'รถบรรทุกอีซูซุ',
];

export const NON_OMO_BRANCHES = [
  '40280208',
  '40280302',
  '40280303',
  '40280305',
  '40280306',
  '40280307',
  '40280309',
  '40280310',
  '40280311',
  '40280314',
];
